import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Products from './pages/Products';
import KesarProduct from './pages/KesarProduct';
import KesarGuide from './pages/KesarGuide';
import About from './pages/About';
import ArticlesList from './pages/ArticlesList';
import Article1 from './pages/Article1';
import Article2 from './pages/Article2';
import Contact from './pages/Contact';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/kesar" element={<KesarProduct />} />
            <Route path="/products/kesar/guide" element={<KesarGuide />} />
            <Route path="/about" element={<About />} />
            <Route path="/articles" element={<ArticlesList />} />
            <Route path="/articles/pure-kashmiri-kesar-clinically-proven-elixir" element={<Article1 />} />
            <Route path="/articles/kashmir-where-kesar-is-guarded" element={<Article2 />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;